import { FetchBaseQueryError, createApi } from '@reduxjs/toolkit/query/react'
import { OrderDetailsDefaults } from './types'
import { ajaxOptions } from './ajax'
import { baseApi } from './utils'

export const multipleQueriesApi = createApi({
	reducerPath: 'multipleQueries',
	...baseApi('/'),
	endpoints: builder => ({
		getOrderDetailsAndApprovalsData: builder.query<
			OrderDetailsDefaults,
			{
				businessId: string
				driverId: string
				rentalVehicleGroupId: string
				tariffBandId: string
				reasonForHireId: string
				numDays: number
			}
		>({
			async queryFn(
				{ businessId, driverId, rentalVehicleGroupId, reasonForHireId, tariffBandId, numDays },
				_queryApi,
				_extraOptions,
				fetchWithBQ
			) {
				try {
					//TODO -need to account for not passing in driverId if new driver added
					const approvalsData = (await fetchWithBQ(
						`api/object/RentalReservation/Authorisers/?businessId=${businessId}&driverId=${driverId}&rentalVehicleGroupId=${rentalVehicleGroupId}&reasonForHireId=${reasonForHireId}&tariffBandId=${tariffBandId}&numDays=${numDays}`
					)) as { data: OrderDetailsDefaults }
					const orderDetailsDefaultsData = (await fetchWithBQ(`ajax/get-res-business-order-defaults/?id=${businessId}/`)) as {
						data: Pick<OrderDetailsDefaults, 'authorisers' | 'selectedAuthoriser'>
					}

					const data = { ...approvalsData.data, ...orderDetailsDefaultsData.data }

					return { data }
				} catch (error) {
					{
						error as FetchBaseQueryError
					}
				}
			},
		}),
		saveAddress: builder.mutation({
			query(body) {
				const settings = { url: 'address/edit.php', method: 'POST', body }
				return ajaxOptions(settings)
			},
		}),
	}),
})

export const { useGetOrderDetailsAndApprovalsDataQuery, useSaveAddressMutation } = multipleQueriesApi
